module.exports = __webpack_public_path__ + "static/david_nguyen-4b9b32253bcda474631345aa4c31c46e.jpg";